import i18n from '../main'
// 表单验证规则
export const Validation = {
  // 登录-用户名
  userName: (rule, value, callback) => {
    if (value.length < 3 || value.length > 12) {
      callback(new Error ('用户名为3-12个字符'))
    } else if (!/^[^\s]*$/.test(value)) {
      callback(new Error('用户名/员工编号不能存在空格'))
    } else {
      callback()
    }
  },
  // 密码不能为空
  username: (rule, value, callback) => {
    if (value === '') {
      callback(new Error('用户名不能为空'))
    } else {
      callback()
    }
  },
  // 登录-密码
  userPassword: (rule, value, callback) => {
    let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
    if (
      !reg.test(
        value
      ) || /[\u4E00-\u9FA5]/g.test(value)
    ) {
      callback(new Error(i18n.t('loginPage.mmzswzmsztszf')))
    } else {
      callback()
    }
  },
  // 密码不能为空
  passWord: (rule, value, callback) => {
    if (value === '') {
      callback(new Error('密码不能为空'))
    } else {
      callback()
    }
  },
  // 登录 -修改密码
  originPassword: (rule, value, callback) => {
    if (!/^\d{6}$/.test(value)) {
      callback(new Error('密码为身份证后6位'))
    } else {
      callback()
    }
  },
  // 忘记密码-手机号
  phoneNumber: (rule, value, callback) => {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error('手机号为11位数字'))
    } else {
      callback()
    }
  },
  // 忘记密码-验证码
  verificationCode: (rule, value, callback) => {
    if (value === '') {
      callback(new Error('验证码不能为空'))
    } else {
      callback()
    }
  },
  // 忘记密码-密码
  findPassword: (rule, value, callback) => {
    let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
    if (
      !reg.test(
        value
      ) || /[\u4E00-\u9FA5]/g.test(value)
    ) {
      callback(new Error(i18n.t('loginPage.mmzswzmsztszf')))
    } else {
      callback();
    }
  },
  // 注册-用户类型
  userType: (rule, value, callback) => {
    if (value === '') {
      callback(new Error('用户类型不能为空'))
    } else {
      callback()
    }
  },
  // 注册-用户名
  signUserName: (rule, value, callback) => {
    if (value.length < 3 || value.length > 12) {
      callback(new Error('用户名为3-12个字符'))
    } else if (!/^[^\s]*$/.test(value)) {
      callback(new Error('用户名不能存在空格'))
    } else if (!/^.*[^\d].*$/.test(value)) {
      callback(new Error('用户名不为纯数字'))
    } else {
      callback()
    }
  },
  // 注册-员工编号
  signUserCode: (rule, value, callback) => {
    if (!/^(\d{8})$/.test(value)) {
      callback(new Error('员工编码为8位数字'))
    } else {
      callback()
    }
  },
  // 注册-姓名
  signName: (rule, value, callback) => {
    if (!/^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/.test(value)) {
      callback(new Error('姓名格式不正确'))
    } else if (!/^[^\s]*$/.test(value)) {
      callback(new Error('姓名不能存在空格'))
    } else {
      callback()
    }
  },
  // 注册-手机号
  signPhoneNumber: (rule, value, callback) => {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error('手机号为11位数字'))
    } else {
      callback()
    }
  },
  // 注册-密码
  signPassword: (rule, value, callback) => {
    if (
      !/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(
        value
      ) || /[\u4E00-\u9FA5]/g.test(value)
    ) {
      callback(new Error("密码至少为8位字母、数字、特殊字符组合"));
    } else {
      callback();
    }
  },
  // 注册-身份证
  signIDNumber: (rule, value, callback) => {
    if (!/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/.test(value)) {
      callback(new Error('身份证为18位字符'))
    } else {
      callback()
    }
  },
  // 注册-邮箱
  signEmail: (rule, value, callback) => {
    if (!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
      callback(new Error('邮箱格式不正确'))
    } else {
      callback()
    }
  }
}
